export const LinkedToImportedAccountErrorToast = () => (
    <div>
        Can&apos;t change entity or financial account while document is linked
        to an imported account.
    </div>
);
